/*******************************************************************************
 * Copyright (c) 2024 Passport Fintech Inc. All Rights Reserved.
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential.
 ******************************************************************************/

export interface ParticipantUser {
  participantId: string;
  name?: string;
  createdAt?: string;
  updatedAt?: string;
  identificationNumber?: string;
}

export interface ParticipantUserApiResponse {
  participant_id: string;
  name?: string;
  created_at?: string;
  updated_at?: string;
  identification_number?: string;
}

export const participantUserFromApiResponse = (
  response: ParticipantUserApiResponse
): ParticipantUser => {
  return {
    participantId: response.participant_id,
    name: response.name,
    createdAt: response.created_at,
    updatedAt: response.updated_at,
    identificationNumber: response.identification_number,
  };
};
